import request from '@/utils/request'

// 合作伙伴
export function getCooperative (data) {
  return request({
    url: '/CooperativeApi/Index',
    method: 'post',
    data
  })
}
